import React from 'react';
import { Box, Container, Typography, Grid, Link, Stack, IconButton, Button, Divider } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
    return (
        <Box sx={{ backgroundColor: '#F7F4EF', pt: 10, pb: 4 }}>
            <Container maxWidth="lg">
                <Grid container spacing={8}>
                    {/* Brand Section */}
                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontFamily: "'cormorantgaramond', serif",
                                fontWeight: 700,
                                fontSize: '1.8rem',
                                color: '#1a1a1a',
                                mb: 3
                            }}
                        >
                            WillowStyle.store
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "'Sora', sans-serif",
                                fontSize: '0.9rem',
                                color: '#666',
                                lineHeight: 1.6,
                                mb: 4,
                            }}
                        >
                            Where style blossoms. Premium ethnic and western wear for the modern Indian woman.
                        </Typography>
                        <Stack direction="row" spacing={1.5}>
                            {[InstagramIcon, FacebookIcon, TwitterIcon].map((Icon, index) => (
                                <IconButton
                                    key={index}
                                    sx={{
                                        backgroundColor: '#eee9e2',
                                        color: '#d4a0a6',
                                        '&:hover': {
                                            backgroundColor: '#d4a0a6',
                                            color: 'white',
                                        },
                                        width: 36,
                                        height: 36,
                                    }}
                                >
                                    <Icon sx={{ fontSize: '1.1rem' }} />
                                </IconButton>
                            ))}
                        </Stack>
                    </Grid>

                    {/* Quick Links */}
                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography
                            sx={{
                                fontFamily: "'cormorantgaramond', serif",
                                fontWeight: 700,
                                fontSize: '1.3rem',
                                color: '#1a1a1a',
                                mb: 3
                            }}
                        >
                            Quick Links
                        </Typography>
                        <Stack spacing={1.5}>
                            {['Home', 'Shop', 'About Us', 'Contact'].map((item) => (
                                <Link
                                    key={item}
                                    href="#"
                                    underline="none"
                                    sx={{
                                        fontFamily: "'Sora', sans-serif",
                                        fontSize: '0.9rem',
                                        color: '#666',
                                        '&:hover': { color: '#1a1a1a' }
                                    }}
                                >
                                    {item}
                                </Link>
                            ))}
                        </Stack>
                    </Grid>

                    {/* Policies */}
                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography
                            sx={{
                                fontFamily: "'cormorantgaramond', serif",
                                fontWeight: 700,
                                fontSize: '1.3rem',
                                color: '#1a1a1a',
                                mb: 3
                            }}
                        >
                            Policies
                        </Typography>
                        <Stack spacing={1.5}>
                            {['Shipping Policy', 'Return Policy', 'Terms & Conditions', 'Privacy Policy'].map((item) => (
                                <Link
                                    key={item}
                                    href="#"
                                    underline="none"
                                    sx={{
                                        fontFamily: "'Sora', sans-serif",
                                        fontSize: '0.9rem',
                                        color: '#666',
                                        '&:hover': { color: '#1a1a1a' }
                                    }}
                                >
                                    {item}
                                </Link>
                            ))}
                        </Stack>
                    </Grid>

                    {/* Get in Touch */}
                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Typography
                            sx={{
                                fontFamily: "'cormorantgaramond', serif",
                                fontWeight: 700,
                                fontSize: '1.3rem',
                                color: '#1a1a1a',
                                mb: 3
                            }}
                        >
                            Get in Touch
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "'Sora', sans-serif",
                                fontSize: '0.9rem',
                                color: '#666',
                                mb: 1
                            }}
                        >
                            Email: hello@bloomstitch.com
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "'Sora', sans-serif",
                                fontSize: '0.9rem',
                                color: '#666',
                                mb: 3
                            }}
                        >
                            Phone: +91 63026 60450
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<WhatsAppIcon />}
                            sx={{
                                backgroundColor: '#d4a0a6',
                                borderRadius: '25px',
                                textTransform: 'none',
                                fontFamily: "'Sora', sans-serif",
                                fontSize: '0.9rem',
                                fontWeight: 600,
                                px: 3,
                                py: 1,
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: '#c48f95',
                                    boxShadow: 'none',
                                }
                            }}
                        >
                            WhatsApp Us
                        </Button>
                    </Grid>
                </Grid>

                <Divider sx={{ mt: 8, mb: 4, opacity: 0.1, borderColor: '#1a1a1a' }} />

                <Typography
                    align="center"
                    sx={{
                        fontFamily: "'Sora', sans-serif",
                        fontSize: '0.8rem',
                        color: '#999',
                        letterSpacing: '0.02em'
                    }}
                >
                    © 2026 WillowStyle.co. All rights reserved. Crafted with love for modern women.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
